import { schema } from 'normalizr';

const introduction = new schema.Entity(
  'contents',
  {},
  {
    processStrategy: (value: any, parent: any, key: string) => {
      const result = {
        ...value,
        value: undefined
      };
      switch (key) {
        case 'children':
          result.url = `introduction/${value.id}.html`;
          break;
        case 'introductions':
          result.url = `introduction/${value.id}.html`;
          break;
        default:
          throw new Error('Content entity key is not supported');
      }
      return result;
    }
  }
);

introduction.define({
  children: [introduction]
});

export default introduction;
